/* src/app/requests/requests.component.scss */
.requests-block {
  height: calc(100% - 50px);
  position: relative;
}
.request-list,
.request-details {
  height: 100%;
  overflow: auto;
}
.request-list {
  border-right: 1px solid rgba(0, 0, 0, 0.125);
  float: left;
  overflow: hidden;
  width: 300px;
}
.request-details {
  width: calc(100% - 300px);
}
.navbar-start {
  justify-content: start;
}
.list-group-item__request-text {
  padding-left: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row_cdar i {
  color: orange;
  font-size: 24px;
  margin-right: 6px;
}
.portal-title {
  display: block;
  padding: 0 10px;
  margin: 0;
  height: 50px;
  line-height: 45px;
  font-size: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top: none;
}
.list-group-item.active {
  background-color: #e0e0e0 !important;
  border-color: rgba(0, 0, 0, 0.125) !important;
  color: rgb(99, 99, 99) !important;
}
.list-group-item.active:hover {
  background-color: #d6d6d6 !important;
  color: rgb(99, 99, 99) !important;
  border-color: rgba(0, 0, 0, 0.125) !important;
}
.list-group-item:hover {
  background-color: #d6d6d6 !important;
  color: rgb(99, 99, 99) !important;
  border-color: rgba(0, 0, 0, 0.125) !important;
}
.icon-status_all-requests {
  color: black;
}
.content-container {
  position: relative;
  height: calc(100% - 60px);
  overflow: hidden;
}
.left-panel {
  background-color: #f8f9fa !important;
  color: black;
  border-right: 1px solid #d6d8db;
  max-width: 250px;
}
.create-request-link-btn {
  border: none;
  outline: none;
  background-color: transparent;
  width: 100%;
  padding: 0;
  text-align: left;
  height: 50px;
  text-align: left;
  padding: 0 10px 0 16px;
  font-size: 16px;
  color: black;
  cursor: pointer;
  border-bottom: 1px solid #d6d6d6;
}
.create-request-link-btn:hover {
  background-color: #d6d6d6;
}
.create-request-link-btn i {
  color: black;
}
.main-content {
  height: 100%;
  transition: padding-left 0.4s cubic-bezier(0, 0, 0.3, 1);
  padding-left: 250px;
}
@media (max-width: 1000px) {
  .main-content {
    padding: 0;
  }
  .background {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #000;
    pointer-events: auto;
    opacity: 0.48;
    z-index: 9;
  }
}
@media (max-width: 730px) {
  .content-container {
    height: calc(100% - 120px);
  }
}
@media (max-width: 732px) {
  .request-list {
    width: 100%;
  }
  .request-details {
    display: none;
  }
}
@media (max-width: 600px) {
  .portal-title {
    display: none;
  }
  .requests-block {
    height: 100%;
  }
}
/*# sourceMappingURL=requests.component.css.map */
